<template>
  <div class="case-aticle aticle-container">
    <header
      class="aticle-hd"
      :style="
        caseItem.banner ? `background-image: url(${caseItem.banner});` : ''
      "
    >
      <div
        class="case-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h2 class="case-hd-title">基础设施建设行业对该狄诺尼有着高度的信赖</h2>
        <h2 class="case-hd-title">
          这使得我们成为业内备受推崇且值得信赖的企业
        </h2>
      </div>
    </header>
    <div class="topTitle">
      <div class="flex-row">
        <div style="width: 80px">当前位置：</div>
        <div class="backBtn" @click="back('/intelligent/management')">
          行业案例&nbsp;> &nbsp;
        </div>
        <el-tooltip :content="caseItem.title" placement="bottom-start">
          <div class="caseTitle">{{ caseItem.title }}</div>
        </el-tooltip>
      </div>
    </div>

    <div class="aticle">
      <div class="title">{{ caseItem.title }}</div>

      <div class="line"></div>

      <div v-html="processedContent" class="content"></div>
    </div>
  </div>
</template>

<script>
import { expressway, bridge, tunnel, rail, facilities, more } from "./cases.js";

import picExpressway1 from "@/assets/images/intelligentImg/cases/expressway-text-1.png";
import picExpressway2 from "@/assets/images/intelligentImg/cases/expressway-text-2.png";
import picExpressway3 from "@/assets/images/intelligentImg/cases/expressway-text-3.png";
import picExpressway4 from "@/assets/images/intelligentImg/cases/expressway-text-4.png";
import picExpressway5 from "@/assets/images/intelligentImg/cases/expressway-text-5.png";
import picExpressway6 from "@/assets/images/intelligentImg/cases/expressway-text-6.png";

import picBridge1 from "@/assets/images/intelligentImg/cases/bridge-text-1.png";
import picBridge2 from "@/assets/images/intelligentImg/cases/bridge-text-2.png";
import picBridge3 from "@/assets/images/intelligentImg/cases/bridge-text-3.png";

import picTunnel1 from "@/assets/images/intelligentImg/cases/tunnel-text-1.png";
import picTunnel2 from "@/assets/images/intelligentImg/cases/tunnel-text-2.png";
import picTunnel3 from "@/assets/images/intelligentImg/cases/tunnel-text-3.png";
import picTunnel4 from "@/assets/images/intelligentImg/cases/tunnel-text-4.png";

import picRail1 from "@/assets/images/intelligentImg/cases/rail-text-1.png";
import picRail2 from "@/assets/images/intelligentImg/cases/rail-text-2.png";
import picRail3 from "@/assets/images/intelligentImg/cases/rail-text-3.png";
import picRail4 from "@/assets/images/intelligentImg/cases/rail-text-4.png";
import picRail5 from "@/assets/images/intelligentImg/cases/rail-text-5.png";

import picFacilities1 from "@/assets/images/intelligentImg/cases/facilities-text-1.jpg";
import picFacilities2 from "@/assets/images/intelligentImg/cases/facilities-text-2.png";
import picFacilities3 from "@/assets/images/intelligentImg/cases/facilities-text-3.png";
import picFacilities4 from "@/assets/images/intelligentImg/cases/facilities-text-4.png";
import picFacilities5 from "@/assets/images/intelligentImg/cases/facilities-text-5.png";

import picMore1 from "@/assets/images/intelligentImg/cases/more-text-1.png";
import picMore2 from "@/assets/images/intelligentImg/cases/more-text-2.png";
import picMore3 from "@/assets/images/intelligentImg/cases/more-text-3.png";

export default {
  name: "caseDetail",
  props: {},
  components: {},
  data() {
    return {
      anchor: "Cases",
      caseType: "expressway",
      caseItem: {
        title: "",
        banner: "",
        content: "",
      },
      // JSON中的图片，使用映射关系替换
      replacements: {
        "{picExpressway1}": picExpressway1,
        "{picExpressway2}": picExpressway2,
        "{picExpressway3}": picExpressway3,
        "{picExpressway4}": picExpressway4,
        "{picExpressway5}": picExpressway5,
        "{picExpressway6}": picExpressway6,

        "{picBridge1}": picBridge1,
        "{picBridge2}": picBridge2,
        "{picBridge3}": picBridge3,

        "{picTunnel1}": picTunnel1,
        "{picTunnel2}": picTunnel2,
        "{picTunnel3}": picTunnel3,
        "{picTunnel4}": picTunnel4,

        "{picRail1}": picRail1,
        "{picRail2}": picRail2,
        "{picRail3}": picRail3,
        "{picRail4}": picRail4,
        "{picRail5}": picRail5,

        "{picFacilities1}": picFacilities1,
        "{picFacilities2}": picFacilities2,
        "{picFacilities3}": picFacilities3,
        "{picFacilities4}": picFacilities4,
        "{picFacilities5}": picFacilities5,

        "{picMore1}": picMore1,
        "{picMore2}": picMore2,
        "{picMore3}": picMore3,
      },
    };
  },
  computed: {
    processedContent() {
      let content = this.caseItem.content;
      for (const [placeholder, url] of Object.entries(this.replacements)) {
        // 全局替换所有出现（使用 g 标志）
        content = content.replace(new RegExp(placeholder, "g"), url);
      }
      return content;
    },
  },
  created() {},
  mounted() {
    this.anchor = this.$route.query.anchor;
    this.caseType = this.$route.query.type;

    if (this.caseType === "expressway") {
      this.caseItem = expressway;
    } else if (this.caseType === "bridge") {
      this.caseItem = bridge;
    } else if (this.caseType === "tunnel") {
      this.caseItem = tunnel;
    } else if (this.caseType === "rail") {
      this.caseItem = rail;
    } else if (this.caseType === "facilities") {
      this.caseItem = facilities;
    } else if (this.caseType === "more") {
      this.caseItem = more;
    }
  },
  methods: {
    back(url) {
      this.$uniFun.openInCurrentTab(`${url}?&anchor=${this.anchor}`);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/common.scss";
.case-aticle.aticle-container {
  background: white;
  padding-bottom: 38px;
  .aticle-hd {
    width: 100%;
    height: 200px;
    background-image: url("~@/assets/images/academy/academy-hd_bg.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .case-hd-wrapper {
      width: 1049px;
      padding-top: 60px;
      margin: 0 auto;
    }
    .case-hd-title {
      font-weight: 600;
      font-size: 24px;
      color: #ffffff;
      line-height: 40px;
      font-style: normal;
    }
  }
  .topTitle {
    width: 100%;
    height: 64px;
    margin: 0 auto;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: left;
    border-bottom: 1px solid #d8d8d8;
    position: sticky;
    top: 80px;
    background: #fff;
    z-index: 20;
    > div {
      width: 1049px;
      margin: 0 auto;
      > div {
        height: 64px;
        line-height: 64px;
      }
      .caseTitle {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .backBtn {
    cursor: pointer;
    line-height: 64px;
    width: 79px;
  }
  .backBtn:hover {
    color: #0035fb;
    border-bottom: 2px solid #0035fb;
  }

  .aticle {
    margin: 38px auto 0;
    width: 1048px;
    background: #fbfbfb;
    padding: 29px 76px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    .title {
      font-weight: 600;
      font-size: 24px;
      color: #333333;
      line-height: 32px;
      text-align: center;
      font-style: normal;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #dbdbdb;
    }

    .content {
      margin-top: 24px;

      h2 {
        font-weight: bold;
        font-size: 16px;
        color: #666666;
        line-height: 32px;
        text-align: justify;
        font-style: normal;
      }

      p {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 1.5;
        text-align: justify;
        margin: 15px 0px;
      }

      figcaption {
        font-weight: 400;
        font-size: 32px;
        color: #666666;
        line-height: 1.5;
        text-align: center;
      }
      img {
        max-width: 100%;
      }
      ul,
      ol {
        list-style: disc outside !important; /* ul 默认圆点 */
        padding-left: 2em;
        margin: 0.8em 0;
      }

      ol {
        list-style: decimal outside !important; /* ol 默认数字 */
      }

      li {
        display: list-item !important;
        list-style: inherit !important;
        margin: 0.5em 0;
      }
    }
    .videoBox {
      width: 100%;
      height: 590px;
      padding: 10px;
      box-sizing: border-box;
      background: #e4e7ed;
      border-radius: 8px;
      border: 1px solid #f8f8f8;
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
